import { useContext } from "react";
import styled from "styled-components";
import { naver, kakao, google, authorize } from "auth/DeprecatedOAuth";
import client from "api/WookAxios";
import ModalContext from "components/contexts/ModalContext";
import MenuContext from "header/MenuContext";
import { useAuth } from "auth/useAuth";
import naverOAuth from "images/naverLogoButton.png";
import kakaoOAuth from "images/kakao_oauth_large.png";
import googleOAuth from "images/google_oauth.svg";
import log from "loglevel";
import { PiDotDuotone } from "react-icons/pi";
import { CONFIG } from "config";
import { API_PATHS } from "constants/api";
import { OAUTH_PROVIDERS } from "constants/provider";
import { parseErrors } from "lib/errors/parse";
import { toast } from "sonner";
import { useLocation, useNavigate } from "react-router-dom";
import { handleThrottle } from "lib/errors/handle";
// import { AiOutlineClose } from "react-icons/ai";

const ModalFrame = styled.div`
  // display: ${(props) => (props.$visible ? "flex" : "none")};
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  // align-items: center;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgb(45, 49, 45, 0.5);
  z-index: 1010;
`;

// const TitleBar = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   width: 300px;
//   height: 40px;
//   background: skyblue;
// `;

// const Title = styled.div`
//   // background: red;
//   // margin: 0 auto;
//   position: absolute;
//   text-align: center;
//   // flex: 1;
// `;

// const Close = styled.div`
//   // display: flex;
//   margin-left: auto;
//   // margin-right: auto;
//   // float: right;
//   // background: blue;
// `;

const Modal = styled.div`
  position: relative;
  margin: 0 auto;
  top: 120px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  border-radius: 20px;
  width: 350px;
  height: 450px;
  background: #fafbfa;
  background: white;
  opacity: 1;
`;

const Title = styled.div`
  // height: 40px;
  // background: red;
  width: 280px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 35px;
  font-weight: 500;
  color: #464646;
  padding-top: 10px;
  padding-left: 10px;
`;

const StyledForm = styled.form`
  // background: coral;
  width: 280px;
  padding-top: 20px 0;
`;

const StyledInput = styled.input`
  width: 98.5%;
  height: 40px;
  box-sizing: border;
  border-radius: 4px;
  border: none;
  margin-bottom: 10px;
  background: #eeeeee;

  // outline: none;

  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  color: #363636;

  &::placeholder {
    color: #black;
  }

  &:focus {
    color: black;
  }
`;

const StyledSubmit = styled.input`
  // background: lightblue;
  width: 100%;
  height: 40px;
  border-radius: 4px;
  border: none;
  background: pink;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  color: #363636;
`;

const ForgotBar = styled.div`
  // background: red;
  box-sizing: border-box;  
  width: 280px;
  margin-top: 2px;
  margin-bottom: 12px;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: space-between;
`;

const ForgotTextButton = styled.div`
  color: Plum;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 13px;
  &:hover {
    background: lightgray;
  }
`;

const Providers = styled.div`
  width: 280px;
`;

const Provider = styled.div`
  display: flex;
  justify-content: left;
  border-radius: 4px;
  width: 100%;
  height: 40px;
  margin: 5px 0px;
  background: white;
  cursor: pointer;
  // border: 0.3px gray solid;
`;

const Naver = styled(Provider)`
  background: #03c75a;
`;

const Kakao = styled(Provider)`
  background: #ffe500;
`;

const Google = styled(Provider)`
  background: #f2f2f2;
`;

const Logo = styled.div`
  width: 40px;
  overflow: hidden;
`;

const Label = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-right: 20px;
  font-size: 15px;
  // background: red;
`;

const StatusBar = styled.div`
  box-sizing: border-box;  
  width: 280px;
  padding-top: 12px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: space-between;
  // background: red;
`;

const StatusTextButton = styled.div`
  color: blue;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  &:hover {
    background: lightgray;
  }
`;

export const LoginModal = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { modalState, modalActions } = useContext(ModalContext);
  const { syncAuth } = useAuth();
  let oauthWindow = null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      username: e.target.username.value,
      password: e.target.password.value,
    };

    if (data.username === '') {
      alert('아이디를 입력하세요');
      return;
    }

    if (data.password === '') {
      alert('비밀번호를 입력하세요');
      return;
    }

    try {
      const response = await client.login(data);
      log.debug('LOGIN_SUCCESS', response.data);
      syncAuth();
    } catch (e) {
      log.debug('LOGIN_FAILED', e);
      const throttled = handleThrottle(e.response);
      if (throttled) return;
      const errors = parseErrors(e.response);
      toast.error(errors[0].message);
    } finally {
      modalActions.closeLogin();
    }
  };

  const handleNaver = async () => {
    modalActions.closeLogin();
    window.location.href = `${API_PATHS.OAUTH_LOGIN(OAUTH_PROVIDERS.NAVER)}`;
  };

  const handleKakao = () => {
    modalActions.closeLogin();
    window.location.href = `${API_PATHS.OAUTH_LOGIN(OAUTH_PROVIDERS.KAKAO)}`;
  };

  const handleGoogle = () => {
    modalActions.closeLogin();
    window.location.href = `${API_PATHS.OAUTH_LOGIN(OAUTH_PROVIDERS.GOOGLE)}`;    
  };

  const handleRegister = () => {
    modalActions.closeLogin();
    // modalActions.setConsentVisible(true);
    // modalActions.setRegisterCheckVisible(true);
    navigate('/register');
  };

  const handleFindAccount = () => {
    modalActions.closeLogin();
    navigate('/find-account', {
      state: {
        from: location,
      }
    });    
  };

  const handleRestPassword = () => {
    modalActions.closeLogin();
    navigate('/reset-password', {
      state: {
        from: location,
      }
    });    
  };

  const handleClose = () => {
    modalActions.closeLogin();
  };

  return modalState.loginVisible && (
    <ModalFrame>
      <Modal>
        <Title>로그인</Title>
        <StyledForm onSubmit={handleSubmit}>
          <StyledInput name="username" placeholder="      아이디" />
          <StyledInput name="password" type="password" placeholder="      비밀번호" />
          <StyledSubmit type="submit" value="로그인" />
        </StyledForm>
        <ForgotBar>
          <ForgotTextButton onClick={handleFindAccount}>아이디찾기</ForgotTextButton>
          <ForgotTextButton onClick={handleRestPassword}>비밀번호찾기</ForgotTextButton>
        </ForgotBar>
        <Providers>
          <Naver onClick={handleNaver}>
            <Logo><img src={naverOAuth} alt="naver" height="100%" /></Logo>
            <Label>네이버 로그인</Label>
          </Naver>
          <Kakao onClick={handleKakao}>
            <Logo><img src={kakaoOAuth} alt="kakao" height="100%" /></Logo>
            <Label>카카오 로그인</Label>
          </Kakao>
          <Google onClick={handleGoogle}>
            <Logo><img src={googleOAuth} alt="google" height="100%" /></Logo>
            <Label>Google 로그인</Label>
          </Google>
        </Providers>
        <StatusBar>
          <StatusTextButton onClick={handleRegister}>회원가입</StatusTextButton>
          <StatusTextButton onClick={handleClose}>닫기</StatusTextButton>
        </StatusBar>
      </Modal>
    </ModalFrame>
  );
};